import ReactMarkdown from 'react-markdown'
import instructions from './Instructions.md'

const Instructions = () => (
  <div className="content">
    <ReactMarkdown>{instructions}</ReactMarkdown>
  </div>
)

export default Instructions
